import React from 'react'
import { IGreenhouseJobListings as IContentfulGreenhouseListings } from 'marketing-site/@types/generated/contentful'
import {
  IProps,
  GreenhouseListings,
  IJobData,
} from 'marketing-site/src/library/components/GreenhouseListings'
import EntryMarker from 'marketing-site/src/components/common/EntryMarker'

export const ContentfulGreenhouseListings = (greenhouseListings: IContentfulGreenhouseListings) => (
  <EntryMarker entry={greenhouseListings}>
    {() => <GreenhouseListings {...transformGreenhouseListings(greenhouseListings)} />}
  </EntryMarker>
)

export function transformGreenhouseListings({ fields }: IContentfulGreenhouseListings): IProps {
  return {
    ...fields,
    title: fields.title,
    noResults: fields.noResultsText,
    data: fields.greenhouseData.fields.data as IJobData, // Need to cast this to force typing
  }
}
